class GeneralService {
  getAppSettings () {
    return apiClient.get('/api/app-settings/')
  }
}

export const generalService = new GeneralService()
